var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "930.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 930.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#555555",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4496 12785 c-27 -8 -79 -28 -115 -45 -62 -30 -204 -170 -2178 -2144 l-2111 -2111 -44 -90 -43 -90 0 -160 0 -160 44 -89 c77 -158 228 -282 392 -321 57 -13 550 -15 4209 -15 3659 0 4152 2 4209 15 164 39 315 163 392 321 l44 89 0 160 0 160 -43 90 -44 90 -2111 2111 c-2288 2286 -2145 2150 -2293 2188 -75 19 -239 20 -308 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436 5224 c-159 -38 -311 -164 -387 -320 l-44 -89 0 -160 0 -160 43 -90 44 -90 2111 -2111 c1945 -1943 2117 -2113 2177 -2143 36 -17 90 -38 120 -46 73 -20 226 -19 304 1 148 38 5 -98 2292 2188 l2112 2111 43 89 44 89 0 161 0 161 -36 75 c-83 174 -227 294 -403 335 -91 22 -8330 21 -8420 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUpDown);
export default __webpack_public_path__ + "static/media/sort-up-down.d3cc4357a407b8e6f8585912428c8d3b.svg";
export { ForwardRef as ReactComponent };